<template>
    <div class="page-wrapper">
        <div class="page-bg dark-bg"></div>

            <TopBarDetail
                type="list"
                title="ประกาศรายชื่อผู้โชคดี"
                noShowPoint
                @clickBack="clickBack()" />
            <div class="page-content" v-if="content">
                <!-- <div id="banner">
                    <div class="text-banner">
                        <div class="title-top">{{lbl.announce.announce_tile}}</div>
                        <div class="title-bottom">
                            <span class="sub-title-top">{{lbl.announce.activity}}</span>
                            <span class="sub-title-bottom">{{lbl.announce.prize}}</span>
                        </div>
                    </div>
                    <div class="img-banner">
                        <div class="img-item">
                            <img :src="displayImage()" alt="">
                        </div>
                    </div>
                </div> -->
                <div>
                    <img class="main_image" :src="displayImage(content.winnerMainPicture)" alt="">
                </div>
                <div v-if="content.isWinner">
                    <div class="mid-content">
                        <div class="text-top">{{content.winnerTitle}}</div>
                        <div class="text-bottom" v-html="content.winnerSubtitle"></div>
                    </div>
                    <div class="content-wrapper">
                        <div v-for="(item, key) in content.winnerList"
                            :key="key">
                            <AnnouncementItem :winner="item" />
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="mid-content">
                        <div class="text-top">{{content.textIsNoWinner}}</div>
                    </div>
                </div>
        </div>
    </div>

</template>

<script>
// mixin
import LocaleMixin from '@/mixin/LocaleMixin'
import ConfigManager from '@/config/ConfigManager'
// service
import AnnounceBlob from '../service/AnnounceBlob'
// component
import TopBarDetail from '@/components/Layout/TopBarPage/TopBarDetail.vue'
import AnnouncementItem from '../component/AnnouncementItem.vue'
export default {
    name: 'Annoument',
    mixins: [LocaleMixin],
    components: {
        TopBarDetail,
        AnnouncementItem
    },
    data: function () {
        return {
            isLoaded: false,
            content: null,
        };
    },
    created: function () {
        this.getContent();
    },
    methods: {
        getContent: function () {
            AnnounceBlob.apiGetAnnounceContent().subscribe((res) => {
                console.log("res", res);
                this.isLoaded = true;
                this.content = res;
            }, (err) => {
                this.isLoaded = true;
                this.errorApi(err);
            });
        },
        displayImage: function (image_name) {
            if (!image_name) return;

            var image_url = ConfigManager.getBlobUrl() + `/webconfig/${ConfigManager.getBlobConfigDev()}/announce/image`;
            image_url = image_url + '/' + image_name;

            return image_url;
        },
        //event
        clickBack: function () {
            this.$router.push('/home');
        },
    }
}
</script>

<style lang="scss" scoped>
@import "../style/announe.scss";
.test-txt {
    position: relative;
    color: red;
}
.main_image{
    width: 100%;
    border-radius: 15px;
}
</style>
<style lang="scss">
.mid-content {
    .text-bottom {
        span{
            padding-left: 5px;
            color: #e3005d;
            font-size: 24px;
        }
    }
}
</style>
